<template>
  <div class="article__view" :id="$route.params.projectName">
    <div v-if="loading" class="loading">Loading...</div>

    <div v-if="error" class="error">{{ error }}</div>

    <div v-if="content && !loading" class="article__view" :id="$route.params.award">
      <div class="article__hero-image" :style="{ backgroundColor: coverImageBackgroundColor }">
        <h1 class="article__heading" v-html="title"></h1>
        <img :src="heroImage" :alt="title" :class="[ coverImageStyle ? 'type--cover' : 'type--contain' ]" v-if="coverPhotoType" />
        <video loop playsinline v-if="!coverPhotoType">
          <source :src="data.coverPhoto" type="video/mp4">
          </video>
        </div>
        <div class="article__project-link" :class="{ 'override-background' : this.mobile && this.isVisible === null, 'no--section' : sectionName.length === 0 }">
          <ul class="project__sections" v-if="desktop && sectionName.length > 0">
            <li
              v-for="(section, index) in sectionName"
              :key="`project-sections-${index}`"
              @click="goToSection(sectionID[index])"
            >
              {{ section }}
            </li>
          </ul>
          <div class="project__sections" v-if="tablet && sectionName.length > 0">
            <div class="sections__title">Sections:</div>
            <select name="sections" @change="goToSectionMobile($event)">
              <option
                v-for="(section, index) in sectionID"
                :key="`project-sections-tablet-${index}`"
                :value="section"
              >
                {{ sectionName[index] }}
              </option>
            </select>
          </div>
          <a :href="projectUrl" target="_blank" v-if="isVisible">{{ projectUrl }}</a>
        </div>
        <div class="article__content pp-grid-container pp-grid-container--blog">
          <div class="article__content-text" v-html="text"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable consistent-return */
import axios from 'axios'
const marked = require('marked')

export default {
  name: 'award',
  props: ['mobile', 'tablet', 'desktop'],
  data() {
    return {
      content: null,
      isActive: false,
      loading: true,
      isVisible: null,
      title: null,
      pageBackground: null,
      headingColor: null,
      heroImage: null,
      coverPhotoType: null,
      coverImageStyle: null,
      coverImageBackgroundColor: null,
      projectUrl: null,
      text: null,
      sectionName: [],
      sectionID: [],
      selectedSection: '',
    };
  },
  created() {
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);

    this.$watch(
      () => this.$route.params,
      () => {
        this.fetchData()
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    )
  },
  watch: {
    $route: 'getId',
  },
  mounted() {
    this.linkNewWindow();
    this.imageCaption();
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    parsedDataAwards(entries) {
      const awards = entries.items.map(award => ({
        title: award.fields.title,
        url: award.fields.url,
        pageBackground: (award.fields.pageBackground) ? award.fields.pageBackground : '#fafafa',
        headingColor: (award.fields.headingColor) ? award.fields.headingColor : '#333',
        // coverPhoto: (award.fields.coverPhoto) ? award.fields.coverPhoto.fields.file.url : null,
        coverPhoto: (award.fields.coverPhoto) ? entries.includes.Asset[0].fields.file.url : null,
        coverPhotoType: (award.fields.coverPhotoType) ? award.fields.coverPhotoType : true,
        coverImageStyle: award.fields.coverImageStyle,
        coverImageBackgroundColor: (award.fields.coverImageBackgroundColor) ? award.fields.coverImageBackgroundColor : '#f3f3f3',
        projectUrl: (award.fields.projectUrl) ? award.fields.projectUrl : null,
        body: award.fields.body,
      }));

      return awards;
    },
    fetchData() {
      axios.get('https://cdn.contentful.com/spaces/f8noytg93sjg/environments/master/entries', {
        params: {
          access_token: '1630b62f51fb8d53cd90ee907e7e442645f1b792f6a0e9915fc64c0032aabc56',content_type: 'awards',
          'fields.url': this.$route.params.award
        }
      })
      .then((response) => {
        const stringifiedResponse = this.parsedDataAwards(response.data);
        this.loading = false
        this.content = stringifiedResponse

        this.getId()
      })
      .catch((error) => {
        console.log(error)
        this.$router.push('/404')
      })
    },
    getArticleIndex() {
      const articleTitle = this.$route.params.award;

      for (let i = 0; i < this.content.length; i += 1) {
        if (this.content[i].url === articleTitle) {
          return i;
        } else if (this.content[i].url !== articleTitle
          && i === this.content.length - 1) {
          return false;
        }
      }
    },
    getId() {
      window.scrollTo(0, 0);
      this.sectionID = [];
      this.sectionName = [];

        document.title = `${this.content[0].title}`;
        // console.log(document.title);

        this.isVisible = this.content[0].projectUrl
        this.title = this.content[0].title
        this.pageBackground = this.content[0].pageBackground
        this.headingColor = this.content[0].headingColor
        this.heroImage = this.content[0].coverPhoto
        this.coverPhotoType = this.content[0].coverPhotoType
        this.coverImageStyle = this.content[0].coverImageStyle
        this.coverImageBackgroundColor = this.content[0].coverImageBackgroundColor

        if (this.isVisible) {
          // this.projectUrl = this.content[0].projectUrl.substring(7);
          this.projectUrl = this.content[0].projectUrl;
        }
        this.text = marked(this.content[0].body);

        this.linkNewWindow();
        this.imageCaption();

        setTimeout(() => {
          document.querySelector('.article__heading').style.color = this.headingColor;
        }, 200);

        // update page background color
        document.documentElement.style.backgroundColor = this.pageBackground;

        setTimeout(() => {
          this.getSections();
        }, 500);
    },
    getSections() {
      const sections = document.querySelectorAll('.article__content-text h3');
      const menu = document.querySelectorAll('.article__project-link')[0];

      this.sectionID = [];
      this.sectionName = [];

      menu.style.backgroundColor = this.pageBackground;

      for (let i = 0; i < sections.length; i += 1) {
        const id = sections[i].getAttribute('id');
        const name = sections[i].getAttribute('id').replace(/[^A-Z0-9]+/ig, ' ');
        this.sectionName.push(name);
        this.sectionID.push(id);
      }
    },
    goToSection(id) {
      console.log(id, document.getElementById(id));
      this.$smoothScroll({
        scrollTo: document.getElementById(id)
      });
    },
    goToSectionMobile(event) {
      this.selectedSection = event.target.value;

      this.$smoothScroll({
        scrollTo: document.getElementById(this.selectedSection)
      });
    },
    highlightSectionMenu() {
      const sections = document.querySelectorAll('.article__content-text h3');
      const sectionMenu = document.querySelectorAll('.project__sections li');
      const heroImage = document.querySelectorAll('.article__hero-image')[0];
      const heroImageOffset = heroImage.offsetHeight + heroImage.offsetTop;

      for (let i = 0; i < sections.length; i += 1) {
        if (i + 1 !== sections.length) {
          if (sections[i].offsetTop + heroImageOffset < window.scrollY
            && window.scrollY < sections[i + 1].offsetTop + heroImageOffset) {
            sectionMenu[i].classList.add('active');
          } else {
            sectionMenu[i].classList.remove('active');
          }
        }

        if (i + 1 === sections.length) {
          if (sections[i].offsetTop + heroImageOffset < window.scrollY) {
            sectionMenu[i].classList.add('active');
          } else {
            sectionMenu[i].classList.remove('active');
          }
        }
        // console.log(window.scrollY, sections[i].offsetTop + heroImageOffset);
      }
    },
    linkNewWindow() {
      setTimeout(() => {
        const links = document.querySelectorAll('.article__content-text a');
        for (let i = 0; i < links.length; i += 1) {
          links[i].setAttribute('target', '_blank');
          // console.log(links[i]);
        }
      }, 2000);
    },
    imageCaption() {
      setTimeout(() => {
        if (document.querySelector('.article__content-text img')) {
          const imageW = document.querySelector('.article__content-text img').offsetWidth;
          const captions = document.querySelectorAll('.article__content-text blockquote');
          // console.log(imageW);
          for (let i = 0; i < captions.length; i += 1) {
            captions[i].style.width = `${imageW} px`;
            // console.log(captions[i]);
          }
        }
      }, 1000);
    },
    handleResize() {
      this.imageCaption();
    },
    handleScroll() {
      if (this.desktop && !this.loading) {
        this.highlightSectionMenu();
      }
    }
  }
};
</script>
